import { getHojeBR } from '../utils/dataBR';

export const ALL_BADGES = [
  {
    slug: 'first_checkin',
    name: 'Primeiro Passo',
    description: 'Você fez seu primeiro check-in.',
    howToEarn: 'Faça seu primeiro check-in do dia.',
    iconSlug: 'seed',
  },
  {
    slug: 'first_note',
    name: 'Voz Interior',
    description: 'Você escreveu sua primeira reflexão.',
    howToEarn: 'Escreva sua primeira reflexão no diário.',
    iconSlug: 'feather',
  },
  {
    slug: 'comunidade_1',
    name: 'Voz na Comunidade',
    description: 'Você compartilhou sua primeira reflexão com a comunidade.',
    howToEarn: 'Compartilhe uma reflexão com a comunidade.',
    iconSlug: 'share',
  },
  {
    slug: 'shares_10',
    name: 'Alma Generosa',
    description: 'Você compartilhou 10 reflexões com a comunidade.',
    howToEarn: 'Compartilhe 10 reflexões com a comunidade.',
    iconSlug: 'share-10',
  },
  {
    slug: 'shares_50',
    name: 'Escritora Ativa',
    description: 'Você compartilhou 50 reflexões com a comunidade.',
    howToEarn: 'Compartilhe 50 reflexões com a comunidade.',
    iconSlug: 'diploma',
  },
  {
    slug: 'streak_7',
    name: 'Semana Inteira',
    description: 'Você escreveu 7 dias seguidos.',
    howToEarn: 'Escreva por 7 dias consecutivos.',
    iconSlug: 'calendar-check',
  },
  {
    slug: 'streak_21',
    name: 'Hábito Formado',
    description: 'Você escreveu 21 dias seguidos.',
    howToEarn: 'Escreva por 21 dias consecutivos.',
    iconSlug: 'flame',
  },
  {
    slug: 'streak_30',
    name: 'Mês Completo',
    description: 'Você escreveu 30 dias seguidos.',
    howToEarn: 'Escreva por 30 dias consecutivos.',
    iconSlug: 'trophy',
  },
  {
    slug: 'livro_iniciado',
    name: 'Primeira Página',
    description: 'Você começou a ler o livro do mês.',
    howToEarn: 'Marque o livro do mês como iniciado na aba Desafios.',
    iconSlug: 'book-open',
  },
  {
    slug: 'livro_1',
    name: 'Leitora em Formação',
    description: 'Você concluiu 1 livro do mês.',
    howToEarn: 'Conclua 1 livro do mês na aba Desafios.',
    iconSlug: 'bookmark',
  },
  {
    slug: 'livro_3',
    name: 'Leitora Dedicada',
    description: 'Você concluiu 3 livros.',
    howToEarn: 'Conclua 3 livros do mês na aba Desafios.',
    iconSlug: 'bookstack',
  },
  {
    slug: 'livro_5',
    name: 'Devoradora de Livros',
    description: 'Você concluiu 5 livros.',
    howToEarn: 'Conclua 5 livros do mês na aba Desafios.',
    iconSlug: 'bookstar',
  },
  {
    slug: 'desafio_1',
    name: 'Comprometida',
    description: 'Você completou seu primeiro desafio.',
    howToEarn: 'Conclua um desafio completo na aba Desafios.',
    iconSlug: 'challenge-star',
  },
  {
    slug: 'desafio_3',
    name: 'Força de Vontade',
    description: 'Você completou 3 desafios.',
    howToEarn: 'Conclua 3 desafios na aba Desafios.',
    iconSlug: 'challenge-flame',
  },
  {
    slug: 'desafio_gratidao',
    name: 'Coração Grato',
    description: 'Você completou o desafio "7 Dias de Gratidão".',
    howToEarn: 'Conclua o desafio "7 Dias de Gratidão".',
    iconSlug: 'challenge-heart',
  },
];

function calcStreak(logs) {
  const completed = logs.filter(l => l.completed);
  if (!completed.length) return 0;
  const dates = completed
    .map(l => new Date(l.date + 'T00:00:00'))
    .sort((a, b) => b - a);
  let count = 0;
  let cursor = new Date(getHojeBR() + 'T00:00:00');
  for (const d of dates) {
    const diff = Math.round((cursor - d) / 86400000);
    if (diff === 0 || diff === 1) { count++; cursor = d; }
    else break;
  }
  return count;
}

export function checkNewBadges(logs, existingSlugs) {
  const completed = logs.filter(l => l.completed);
  const total = completed.length;
  const streak = calcStreak(logs);
  const hasNote = logs.some(l => l.note && l.note.trim().length > 0);

  const results = [];
  const earn = (slug, condition) => {
    if (!existingSlugs.includes(slug) && condition) results.push(slug);
  };

  earn('first_checkin', total >= 1);
  earn('first_note',    hasNote);
  earn('streak_7',      streak >= 7);
  earn('streak_21',     streak >= 21);
  earn('streak_30',     streak >= 30);

  return results;
}

// totalCompartilhadas: number of reflexoes_anonimas shared by the user
export function checkNewShareBadges(totalCompartilhadas, existingSlugs) {
  const results = [];
  const earn = (slug, condition) => {
    if (!existingSlugs.includes(slug) && condition) results.push(slug);
  };

  earn('comunidade_1', totalCompartilhadas >= 1);
  earn('shares_10',    totalCompartilhadas >= 10);
  earn('shares_50',    totalCompartilhadas >= 50);

  return results;
}

// stats: { livrosIniciados: number, livrosConcluidos: number }
export function checkNewBookBadges(stats, existingSlugs) {
  const results = [];
  const earn = (slug, condition) => {
    if (!existingSlugs.includes(slug) && condition) results.push(slug);
  };

  earn('livro_iniciado', stats.livrosIniciados >= 1);
  earn('livro_1',        stats.livrosConcluidos >= 1);
  earn('livro_3',        stats.livrosConcluidos >= 3);
  earn('livro_5',        stats.livrosConcluidos >= 5);

  return results;
}

// desafioId: string do campo id da planilha
// totalConcluidos: número total de desafios concluídos pelo usuário
export function checkNewChallengeBadges(desafioId, totalConcluidos, existingSlugs) {
  const results = [];
  const earn = (slug, condition) => {
    if (!existingSlugs.includes(slug) && condition) results.push(slug);
  };

  earn('desafio_1', totalConcluidos >= 1);
  earn('desafio_3', totalConcluidos >= 3);
  earn('desafio_gratidao', desafioId && desafioId.toLowerCase().includes('gratidao'));

  return results;
}
